import React, {useMemo} from "react";
import {queries} from "shared/api/queries";
import {useTranslation} from "react-i18next";
import useSWR from "swr";
import {Checkbox} from "shared/ui";
import {SectorTypeV2, ShippingSearchParamKey} from "features/shipping/types";
import {LoadingSpinner} from "shared/assets/svgs/LoadingSpinner";
import {useCsvCheckboxFilter} from "features/shipping/hooks/useCsvCheckboxFilter";
import {useSearchParams} from "react-router-dom";

interface Props {
  value?: string | null;
}

export const SectorFilter = ({value}: Props) => {
  const [params] = useSearchParams();
  const {t} = useTranslation(["shipping"]);
  const paramString = useMemo(() => {
    params.delete(ShippingSearchParamKey.designatedSectorCodes);
    return params.toString();
  }, [params]);
  
  const {
          data: sectors, isLoading, mutate
        } = useSWR<SectorTypeV2[]>(queries.shipping.sectors + `?${paramString}`);
  
  const {
          checkAll, handleChangeChecked, handleCheckAll, options, selectedValues,
        } = useCsvCheckboxFilter<SectorTypeV2>({
    externalIsLoading: isLoading,
    externalListData: sectors ?? [],
    queryKey: ShippingSearchParamKey.designatedSectorCodes,
    value,
    toOption: (sector) => ({
      label: `${sector.designated_sector__code}(${sector.count})`,
      value: sector.designated_sector__code,
      className: "item",
    }),
    toValue: (sector) => sector.designated_sector__code,
  });
  
  return (<div className={"column"}>
    <div className={"filter-title"}>
      <span>{t("sector code")}</span>
      <Checkbox rootClassName={"checkAll"} onChange={(event) => handleCheckAll(event.target.checked)}
                checked={checkAll}>
        전체
      </Checkbox>
    </div>
    <div className={"check-group"}>
    <Checkbox.Group
      value={selectedValues}
      options={options}
      onChange={handleChangeChecked}
    />
    {!sectors?.length ? (isLoading ? <LoadingSpinner/> : <span
      className={"nodata"}>데이터가 없습니다</span>) : null}
    </div>
  </div>);
}
